import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { RouterLink } from 'APP/router/constants';
import { navigateTo } from 'APP/router/refs/navigateTo';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class SpaceUserWasBanned extends GroupsEvent<{ spaceId: string }> {
  process(): void {
    const spaceId = this.eventPayload?.spaceId;

    if (!spaceId) {
      return;
    }

    const space = Entities.spacesStore.getById(spaceId);
    const isSpaceOpened =
      Entities.spacesStore.activeSpaceId === spaceId && !Entities.GroupsStore.activeGroup;

    Tasks.space.removeSpaceLocally(spaceId);

    if (isSpaceOpened) {
      navigateTo({ to: RouterLink.Main });
      Tasks.app.showAlert({
        text: t('you_were_banned_alert').replace('{0}', space?.name || ''),
        primaryText: t('common_ok'),
      });
    }
  }
}
